import { styled } from '@styles/theme'

export const StylesPagination = {
	Container: styled('div', {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: '10px',
	}),
	Paginations: styled('div', {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		'& ul': {
			display: 'flex',
			alignItems: 'center',
			gap: '8px',
			listStyle: 'none',

			'@md': {
				gap: '17px',
			},
		},

		'& li': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			background: '#FDFDFD',
			border: '1px solid #DFDEDE',
			borderRadius: '8px',
			width: '32px',
			fontFamily: 'Roboto',
			fontStyle: 'normal',
			fontWeight: 400,
			fontSize: '16px',
			lineHeight: '19px',
			letterSpacing: '0.05em',
			color: '#4C4C4C',
			cursor: 'pointer',

			'& a': {
				padding: '5.5px 5.5px',
			},

			'&.selected': {
				border: '1px solid #29A0D2',
			},

			'&:first-child': {
				background: 'none',
				border: 'none',
				borderRadius: 'none',
				padding: 'none',
				cursor: 'default',
				width: '62px',

				'@md': {
					width: 'initial',
				},
			},

			'&:last-child': {
				background: 'none',
				border: 'none',
				borderRadius: 'none',
				padding: 'none',
				cursor: 'default',
				width: '62px',

				'@md': {
					width: 'initial',
				},
			},

			'@md': {
				width: 'initial',

				'& a': {
					padding: '14.5px 17.5px',
				},
			},
		},
	}),
	Arrow: styled('div', {
		width: '100%',
		display: 'flex',
		gap: '24px',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '14px 14px',
		border: '1px solid #29A0D2',
		borderRadius: '14px',
		maxWidth: 'fit-content',
		color: '#29A0D2',
		cursor: 'pointer',
		fontFamily: 'Roboto',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '18px',
		lineHeight: '19px',

		span: {
			display: 'none',
		},

		'@md': {
			padding: '14px 22.5px',
			span: {
				display: 'block',
			},
		},
	}),
}
